"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const lodash_isequal_1 = __importDefault(require("lodash.isequal"));
const uswds_react_utils_1 = require("@boozallen-uip/uswds-react-utils");
const __1 = require("../..");
const Legend_1 = __importDefault(require("../../Legend/Legend"));
const Radio_1 = __importDefault(require("../Radio"));
function RadioGroup({ children, comparator, disabled = false, error, id, onChange, readOnly = false, tile = false, value }) {
    let label;
    const options = [];
    (0, uswds_react_utils_1.flattenChildren)(react_1.Children.toArray(children)).forEach((child) => {
        const componentType = (0, react_1.isValidElement)(child) ? child.type : undefined;
        switch (componentType) {
            case Legend_1.default:
                label = child;
                break;
            case Radio_1.default:
                options.push(child);
                break;
            default:
                throw new Error(`Invalid child component '${componentType}' used in RadioGroup.`);
        }
    });
    if (!label) {
        throw new Error('A Legend is required inside of a RadioGroup.');
    }
    if (!options.length) {
        throw new Error('At least one Radio must be present inside of a RadioGroup.');
    }
    return ((0, jsx_runtime_1.jsxs)(__1.Fieldset, { children: [(0, react_1.cloneElement)(label, { error }), (0, jsx_runtime_1.jsx)(__1.Form.Error, { error: error }), options.map((child, index) => {
                const optionValue = child.props.value
                    ? child.props.value
                    : child.props.children;
                const checked = (() => {
                    if (comparator) {
                        return comparator(value, optionValue);
                    }
                    if (['function', 'object'].includes(typeof optionValue)) {
                        return (0, lodash_isequal_1.default)(value, optionValue);
                    }
                    return value === optionValue;
                })();
                const onChangeHandler = onChange
                    ? (newValue) => {
                        const event = new CustomEvent('change', {
                            detail: {
                                name: id,
                                value: newValue
                            }
                        });
                        onChange(event);
                    }
                    : undefined;
                return (0, react_1.cloneElement)(child, {
                    checked: checked || false,
                    disabled: disabled || child.props.disabled,
                    groupId: id,
                    groupIndex: index,
                    onChange: onChangeHandler,
                    readOnly,
                    tile
                });
            })] }));
}
exports.default = RadioGroup;
